function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "iconMail",
  transform: "translate(-3691 -932)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_721",
  "data-name": "Rectangle 721",
  transform: "translate(3691 932)",
  fill: "#fff",
  stroke: "#1a1a1a",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("rect", {
  width: 91,
  height: 56,
  rx: 6,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 2,
  width: 87,
  height: 52,
  rx: 4,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Polygon_88",
  "data-name": "Polygon 88",
  transform: "translate(3691 953)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 85.11976623535156 32.99999618530273 L 5.880237579345703 32.99999618530273 L 45.5 2.523271083831787 L 85.1197509765625 33.00000762939453 L 85.11976623535156 32.99999618530273 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 45.49999618530273 5.04652214050293 L 11.76049041748047 30.9999942779541 L 79.23949432373047 30.9999942779541 L 45.49999618530273 5.04652214050293 M 45.49999237060547 0.5232582092285156 C 45.92997741699219 0.5232582092285156 46.35996246337891 0.6615104675292969 46.71941375732422 0.9380073547363281 L 86.33917236328125 31.41475105285645 C 87.85285949707031 32.57912445068359 87.02944183349609 34.99999618530273 85.11975860595703 34.99999618530273 L 5.880241394042969 34.99999618530273 C 3.970542907714844 35.00000762939453 3.147140502929688 32.57912445068359 4.660812377929688 31.41475105285645 L 44.28057098388672 0.9380073547363281 C 44.64002227783203 0.6615104675292969 45.07000732421875 0.5232582092285156 45.49999237060547 0.5232582092285156 Z",
  stroke: "none",
  fill: "#1a1a1a"
})), /*#__PURE__*/React.createElement("g", {
  id: "Polygon_87",
  "data-name": "Polygon 87",
  transform: "translate(3782 967) rotate(180)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 85.11976623535156 32.99999618530273 L 5.880237579345703 32.99999618530273 L 45.5 2.523271083831787 L 85.1197509765625 33.00000762939453 L 85.11976623535156 32.99999618530273 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 45.49999618530273 5.04652214050293 L 11.76049041748047 30.9999942779541 L 79.23949432373047 30.9999942779541 L 45.49999618530273 5.04652214050293 M 45.49999237060547 0.5232582092285156 C 45.92997741699219 0.5232582092285156 46.35996246337891 0.6615104675292969 46.71941375732422 0.9380073547363281 L 86.33917236328125 31.41475105285645 C 87.85285949707031 32.57912445068359 87.02944183349609 34.99999618530273 85.11975860595703 34.99999618530273 L 5.880241394042969 34.99999618530273 C 3.970542907714844 35.00000762939453 3.147140502929688 32.57912445068359 4.660812377929688 31.41475105285645 L 44.28057098388672 0.9380073547363281 C 44.64002227783203 0.6615104675292969 45.07000732421875 0.5232582092285156 45.49999237060547 0.5232582092285156 Z",
  stroke: "none",
  fill: "#1a1a1a"
})));

function SvgIconMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 56,
    viewBox: "0 0 91 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/iconMail.216fa95f.svg";
export { ForwardRef as ReactComponent };